import type { NotificationSettings, NotificationSettingsRequest } from "@shyne/shared/api";
import { api } from "@/lib/api";

export const NotificationRepository = {
    getCurrentUser(): Promise<NotificationSettings> {
        return api.notificationSettings.get();
    },

    upsertCurrentUser(settings: NotificationSettingsRequest): Promise<NotificationSettings> {
        return api.notificationSettings.save(settings);
    },
};
